import { cn } from "@gymflow/helpers";
import { Field, FieldProps, FormikProps } from "formik";

import Label, { LabelProps } from "../base/Label";
import { ErrorMessage } from "../ErrorMessage";
import {
  ImageInputWithModal,
  ImageInputWithModalProps,
} from "../ImageInputWithModal";

type FormImageInputProps<T> = {
  name: keyof T;
  containerClassName?: string;
  label?: string;
  title?: string;
} & Omit<ImageInputWithModalProps, "value" | "onChange"> &
  LabelProps;

export const FormImageInput = <T,>({
  name,
  containerClassName,
  title,
  ...props
}: FormImageInputProps<T>) => {
  return (
    <Field name={name}>
      {({
        field,
        form: { setFieldValue },
        meta: { touched, error },
      }: FieldProps<string, FormikProps<T>>) => {
        const isError = touched && error;
        return (
          <div className={cn("flex flex-col gap-1.5", containerClassName)}>
            {title && (
              <label className="relative flex w-full flex-col gap-1.5">
                {title}
              </label>
            )}

            <ImageInputWithModal
              {...props}
              placeholder={props.placeholder}
              value={{ url: field.value }}
              onChange={(e) => {
                const url = URL.createObjectURL(e);
                setFieldValue(name as string, url);
              }}
            />
            <Label
              label={props.label}
              isRequired={props.isRequired}
              isOptional={props.isOptional}
              helpTooltip={props.helpTooltip}
            />
            {isError && <ErrorMessage text={error} />}
          </div>
        );
      }}
    </Field>
  );
};
